const api = '/api/v1/fixedPhrase.php';
import axios from 'axios';
export const fixedPhraseRepository =  {
    methods: {
        async getAll(){
            return  axios.get(api)
        },
        async update(item){
            return  axios.post(api,item)
        },
    }
};

